declare global {
  interface Window {
    uetq: unknown[]
  }
}

export default defineNuxtPlugin({
  name: 'cookiebot',
  setup() {
    const { cookiebot: cookiebotConfig, mode, isTest } = useRuntimeConfig().public

    const envIsTracked = mode === 'production' || mode === 'staging'

    const cookiebotInstance = shallowRef<typeof Cookiebot | null>(null)

    if (!envIsTracked || isTest || isTestRunner()) {
      return {
        provide: {
          cookiebot: reactive({
            instance: cookiebotInstance,
          }),
        },
      }
    }

    // Set the default for Microsoft UET, Cookiebot will handle the rest
    window.uetq = window.uetq || []
    window.uetq.push('consent', 'default', {
      ad_storage: 'denied',
    })

    const userStore = useUserStore()
    const userIsLoggedIn = computed(() => Boolean(userStore.id))

    // Only enable global tracking logic if environment is tracked
    const trackingEnabled = computed(() => envIsTracked && userIsLoggedIn.value)

    watchEffect(() => {
      const cbInstance = cookiebotInstance.value
      if (!cbInstance) return

      if (trackingEnabled.value && !(cbInstance.consented || cbInstance.declined)) {
        cbInstance.show()
      } else {
        cbInstance.hide()
      }
    })

    const { onLoaded } = useScript(
      {
        src: 'https://consent.cookiebot.com/uc.js',
        type: 'text/javascript',
        defer: true,
        crossorigin: false,
        'data-cbid': cookiebotConfig.id,
      },
      {
        use() {
          return window.Cookiebot
        },
      }
    )

    onLoaded(instance => {
      cookiebotInstance.value = instance
    })

    const cookieConsentChangeEvents: Extract<keyof WindowEventMap, `Cookiebot${string}`>[] = [
      'CookiebotOnConsentReady',
      'CookiebotOnAccept',
      'CookiebotOnDecline',
    ]

    cookieConsentChangeEvents.forEach(eventType => {
      window.addEventListener(eventType, () => {
        if (window.Cookiebot) {
          cookiebotInstance.value = window.Cookiebot
          triggerRef(cookiebotInstance)
        }
      })
    })

    return {
      provide: {
        cookiebot: reactive({
          instance: cookiebotInstance,
        }),
      },
    }
  },
})
